import { Component, computed, input } from '@angular/core';
import { Shipment } from 'src/app/shared/models/shipment';
import { QRCodeComponent } from "angularx-qrcode";
import { TitleCasePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shipment-qrcode',
  imports: [QRCodeComponent, TitleCasePipe],
  templateUrl: './shipment-qrcode.html',
  styleUrl: './shipment-qrcode.scss',
  providers: [TitleCasePipe]
})
export class ShipmentQrcode {
  shipment = input.required<Shipment>();
  displayTrackingInfo = input<boolean>(false);

  private readonly postnordTrackingBaseUrl = environment.couriers.postnord.trackingUrl;
  private readonly dhlTrackingBaseUrl = environment.couriers.dhl.trackingUrl;

  shipmentTrackingLink = computed(() => {
    const shipment = this.shipment();
    if (shipment != null) {
      switch (shipment.Courier.toLowerCase()!) {
        case "postnord":
          return `${this.postnordTrackingBaseUrl}?id=${shipment.ShipmentId}`;
        case "dhl":
          return `${this.dhlTrackingBaseUrl}?submit=1&tracking-id=${shipment.ShipmentId}`;
      }
    }

    return null;
  });
}
